define('areas/organizationmanager/services/mappings',["require", "exports", "areas/organizationmanager/models/bindable", "services/settings", "common/constants"], function (require, exports, vm, settings, constants) {
    "use strict";
    var Mapper = (function () {
        function Mapper() {
        }
        Mapper.mapOrganizationItemFromDTO = function (source) {
            var item = new vm.OrganizationVM();
            var host = settings.Settings.getHost();
            item.id = source.id;
            item.name = source.name;
            item.organizationType = source.organizationType;
            item.externalKey = source.externalKey;
            if (source.organizationType.toLowerCase() != constants.OrganizationTypes.Client.toLowerCase()) {
                item.countClientsOrTaxConsultant = source.clientCount.toString();
            }
            else {
                item.countClientsOrTaxConsultant = source.parentName;
            }
            item.memberCount = source.memberCount;
            item.databaseConnection = source.serverName + "/" + source.databaseName;
            item.uri = source.uri;
            item.url = host.substring(0, host.indexOf(":") + 1) + "//" + item.uri + host.substring(host.indexOf("."));
            if (source.organizationType.toLowerCase() == constants.OrganizationTypes.Client.toLowerCase()) {
                item.url = item.url.replace(source.uri, source.uri.split("\\")[0]);
            }
            return item;
        };
        Mapper.mapNetworkMemberItemFromDTO = function (source) {
            var item = new vm.NetworkMemberVM();
            item.id = source.id;
            item.organizationId = source.organizationId;
            item.loginName = source.loginName;
            item.eMail = source.email;
            item.memberType = this.getMemberType(source.claimsXml);
            item.lastLogin = source.lastLoggedIn != null ? moment(source.lastLoggedIn) : null;
            item.loginCount = source.loginCount ? source.loginCount : 0;
            return item;
        };
        Mapper.getMemberType = function (xml) {
            var xmlDocument = jQuery.parseXML(xml);
            var nodes = xmlDocument.getElementsByTagName("cl");
            for (var i = 0; i < nodes.length; i++) {
                if (nodes[i].attributes.getNamedItem("name").value == "http://claims.addison.de/membertype") {
                    return nodes[i].textContent;
                }
            }
            return null;
        };
        return Mapper;
    }());
    exports.Mapper = Mapper;
});

